<div class="dropdown-wrapper" [class.placeholder-active]="isPlaceholderActive">
  <ngx-bootstrap-multiselect
    [options]="options"
    [settings]="settings"
    [texts]="translatedTexts"
    [disabled]="disabled"
    [(ngModel)]="innerValue"
    (ngModelChange)="onInternalChange($event)"
    (lazyLoad)="emitSearch($event)">
  </ngx-bootstrap-multiselect>

  <div *ngIf="loading" class="loading-overlay">
    <oes-spinner></oes-spinner>
  </div>
</div>
